import {redirectTo, alertBackendError} from "../utils";
import {setAllowRedirect, showLoader} from "./appActions";
import fetch from "../utils/fetch";
import {
    forEach,
    union
} from "lodash";
import {
    RESOURCES,
    RESOURCES_organizationPackageMapping,
    RESOURCES_organizationPackageMapping_forOrg
} from "./constants";
import {getOrganizations} from "./resourceActions";
import {getApiPrefix_lagoon, getApiPrefix_touch} from "../constants";

export const addOrganizationPackageMapping = parametersAsStructure => async (dispatch, getState) => {
    dispatch(showLoader(true));
    try {
        const url = `${getApiPrefix_touch()}/organizationPackageMapping`;
        const response = await fetch(url, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify(parametersAsStructure)
        });

        if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {

            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);

        } else if (response.status === 304) {

            // TODO: handle modified
            console.log('url:', url, ' modified');

        } else if (response.status === 200) {

            dispatch(showLoader(false));

        } else if (response.status === 500 || response.status === 503) {

            alertBackendError({response});
            // dispatch(showLoader(false));

        }
        else
        {
            // other exotic error messages ...
            alertBackendError({response});
            dispatch(showLoader(false));
        }

        return response.status === 200;

    } catch (error) {

        console.log(error);
        alertBackendError();
        dispatch(showLoader(false));
        return false;
    }
};


// for admin ...
export const getOrganizationPackageMapping = id => async (dispatch, getState) => {
    try {
        const response = await fetch(`${getApiPrefix_touch()}/organizationPackageMapping/`);

        if (response.status === 200) {
            const content = await response.json();

            dispatch({
                type: RESOURCES_organizationPackageMapping,
                payload: { organizationPackageMapping: content }
            });

            dispatch(showLoader(false));


        } else if (
            (response.status === 401 || response.status === 403) &&
            getState().app.allowRedirect
        ) {
            dispatch(setAllowRedirect(false));
            const url = await response.text();
            redirectTo(url);
        } else if (response.status === 500 || response.status === 503) {
            alertBackendError({response});
        }

        return response.status === 200;
    } catch (exception) {
        console.log(exception);
        alertBackendError({exception});
        return false;
    }
};

// for user
export const getOrganizationPackageMapping_forMyOrg = () => async ( dispatch, getState ) =>
{
    // new version
    if( 1 )
    {
        let organizationPackageMapping_forMyOrg = await getJSONOrNull({ url: `${getApiPrefix_touch()}/organizationPackageMapping/forMyOrgs` });
        if( organizationPackageMapping_forMyOrg )
        {
            console.log( '%corganizationPackageMapping_forMyOrg','background:red;color:white',{ organizationPackageMapping_forMyOrg } );
            dispatch({
                type: RESOURCES,
                payload: {organizationPackageMapping_forMyOrg: organizationPackageMapping_forMyOrg }
            });
        }
        else
        {
        }
    }

    // old version
    if( 0 )
    {
        let organizationName = '';
        {
            let myOrganizations = await getJSONOrNull({ url: `${getApiPrefix_lagoon()}/auth/requestResource?relationRole=ADMIN,DISPATCHER,MEMBER&type=ORGANIZATION` });

            console.log('%cgetOrganizationPackageMapping_forMyOrg','color:green', {myOrganizations});

            if( myOrganizations && myOrganizations.item )
            {
                let organizationPackageMapping_forMyOrg = [];

                forEach( myOrganizations.item, async ( org ) =>
                {
                    organizationName = org.identifier;

                    console.log('%cgetOrganizationPackageMapping_forMyOrg','color:green', {organizationName });
                    if( organizationName )
                    {
                        let packages  = await getJSONOrNull({ url: `${getApiPrefix_touch()}/organizationPackageMapping/forOrg/` + organizationName });

                        console.log('%cgetOrganizationPackageMapping_forMyOrg ***** ','color:green', { organizationName, organizationPackageMapping_forMyOrg });

                        organizationPackageMapping_forMyOrg = union( organizationPackageMapping_forMyOrg, packages );

                        // M:
                    //     dispatch({
                    //         type: RESOURCES,
                    //         payload: {organizationPackageMapping_forMyOrg: organizationPackageMapping_forMyOrg }
                    //     });
                    }
                });
            }
        }
    }
};

// report errors ?
const getJSONOrNull = async ({ url }) => {
    try {
        const response = await fetch( url );

        if (response.status === 200) {
            const content = await response.json();
            return content;
        }
        else
        {
            let errorText = await response.text();
            console.log({ errorText });
            return null;
        }
        // } else if (
        //     (response.status === 401 || response.status === 403) &&
        //     getState().app.allowRedirect
        // ) {
        //     dispatch(setAllowRedirect(false));
        //     const url = await response.text();
        //     redirectTo(url);
        // } else if (response.status === 500 || response.status === 503) {
        //     alertBackendError({response});
        // }
        //
        // return response.status === 200;
    } catch ( exception ) {
        console.log(exception);
        return null;
        // alertBackendError({exception});
        // return false;
    }
};


// WEBPACK FOOTER //
// ./src/actions/OrganizationPackageMappingActions.js